module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Prelims-head",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Dedicated to…")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Barnes as always, "), _c('br'), _vm._v("and for the hardworking and dedicated "), _c('br'), _vm._v("National Health Service.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2607c8d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398432048_EPUB4.vue
// module id = 69
// module chunks = 0